import { render, staticRenderFns } from "./TheHeaderDropdownHrAlerts.vue?vue&type=template&id=2082c780&scoped=true"
import script from "./TheHeaderDropdownHrAlerts.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownHrAlerts.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownHrAlerts.vue?vue&type=style&index=0&id=2082c780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082c780",
  null
  
)

export default component.exports